export const FETCH_NEWEST_ARTICLES_PENDING = 'FETCH_NEWEST_ARTICLES_PENDING';
export const FETCH_NEWEST_ARTICLES_FULFILLED = 'FETCH_NEWEST_ARTICLES_FULFILLED';
export const FETCH_NEWEST_ARTICLES_FAILED = 'FETCH_NEWEST_ARTICLES_FAILED';
export const FETCH_ARTICLES_PENDING = 'FETCH_ARTICLES_PENDING';
export const FETCH_ARTICLES_FULFILLED = 'FETCH_ARTICLES_FULFILLED';
export const FETCH_ARTICLES_FAILED = 'FETCH_ARTICLES_FAILED';
